/**
 * Water Report Popup — multi-step v4
 * States: wheel → form → done
 */
(function() {
  'use strict';

  const CONFIG = window.WaterReportConfig;
  if (!CONFIG) {
    console.error('Water Report Popup: Configuration not found.');
    return;
  }

  // Wheel segments — winning index 2 (FREE REPORT)
  var SEGMENTS = [
    { label: 'FREE|REPORT', prize: 'report', color: 'blue'  },
    { label: 'TRY|AGAIN',   prize: null,     color: 'white' },
    { label: 'FREE|REPORT', prize: 'report', color: 'blue'  },
    { label: 'TRY|AGAIN',   prize: null,     color: 'white' },
    { label: 'FREE|REPORT', prize: 'report', color: 'blue'  },
    { label: 'TRY|AGAIN',   prize: null,     color: 'white' },
    { label: 'FREE|REPORT', prize: 'report', color: 'blue'  },
    { label: 'TRY|AGAIN',   prize: null,     color: 'white' }
  ];
  var SEG_ANG = 360 / SEGMENTS.length;
  var WINNING_INDEX = 0; // first blue segment

  var isPostcodeValid = false;
  var validationTimeout = null;
  var popupSessionId = null;
  var impressionTracked = false;
  var spinning = false;
  var currentRotation = 0;

  var overlay, modal, closeBtn, form, submitBtn, zipcodeInput, market, marketStorageKey;
  var wheelEl, wheelSvg, hubEl, confettiEl;

  // ── Wheel ────────────────────────────────────────────────────────────

  function buildWheel() {
    var blue = '#2764FF';
    var ns = 'http://www.w3.org/2000/svg';
    wheelSvg.innerHTML = '';

    for (var i = 0; i < SEGMENTS.length; i++) {
      var startAng = -90 + i * SEG_ANG;
      var endAng = startAng + SEG_ANG;
      var r = 100;
      var x1 = r * Math.cos(startAng * Math.PI / 180);
      var y1 = r * Math.sin(startAng * Math.PI / 180);
      var x2 = r * Math.cos(endAng * Math.PI / 180);
      var y2 = r * Math.sin(endAng * Math.PI / 180);
      var d = 'M0,0 L' + x1 + ',' + y1 + ' A' + r + ',' + r + ' 0 0,1 ' + x2 + ',' + y2 + ' Z';
      var fill = SEGMENTS[i].color === 'blue' ? blue : '#FFFFFF';
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      p.setAttribute('fill', fill);
      p.setAttribute('stroke', blue);
      p.setAttribute('stroke-width', '1.5');
      wheelSvg.appendChild(p);
    }

    for (var j = 0; j < SEGMENTS.length; j++) {
      var centerAng = -90 + j * SEG_ANG + SEG_ANG / 2;
      var rLabel = 68;
      var cx = rLabel * Math.cos(centerAng * Math.PI / 180);
      var cy = rLabel * Math.sin(centerAng * Math.PI / 180);
      var seg = SEGMENTS[j];
      var color = seg.color === 'blue' ? '#FFFFFF' : blue;
      var g = document.createElementNS(ns, 'g');
      g.setAttribute('transform', 'translate(' + cx + ',' + cy + ') rotate(' + (centerAng + 90) + ')');
      var txt = document.createElementNS(ns, 'text');
      txt.setAttribute('text-anchor', 'middle');
      txt.setAttribute('dominant-baseline', 'middle');
      txt.setAttribute('fill', color);
      txt.setAttribute('font-family', 'Inter, sans-serif');
      txt.setAttribute('font-weight', '600');
      txt.setAttribute('letter-spacing', '0.5');
      var parts = seg.label.split('|');
      if (parts.length > 1) {
        txt.setAttribute('font-size', '10');
        var line1 = document.createElementNS(ns, 'tspan');
        line1.setAttribute('x', '0'); line1.setAttribute('dy', '-6');
        line1.textContent = parts[0];
        var line2 = document.createElementNS(ns, 'tspan');
        line2.setAttribute('x', '0'); line2.setAttribute('dy', '13');
        line2.textContent = parts[1];
        txt.appendChild(line1); txt.appendChild(line2);
      } else {
        txt.setAttribute('font-size', '10');
        txt.textContent = seg.label;
      }
      g.appendChild(txt);
      wheelSvg.appendChild(g);
    }
  }

  function spin() {
    if (spinning) return;
    spinning = true;
    hubEl.classList.remove('is-pulse');

    var segCenterFromTop = WINNING_INDEX * SEG_ANG + SEG_ANG / 2;
    var extraSpins = 6;
    var finalRotation = extraSpins * 360 - segCenterFromTop + (Math.random() * (SEG_ANG * 0.4) - SEG_ANG * 0.2);

    currentRotation += finalRotation;
    wheelEl.style.transform = 'rotate(' + currentRotation + 'deg)';

    setTimeout(function() {
      fireConfetti();
      setState('form');
      spinning = false;
    }, 5000);
  }

  function fireConfetti() {
    if (!confettiEl) return;
    var colors = ['#2764FF', '#7098FF', '#E1EAFF', '#A7C0FF', '#C9FF00'];
    confettiEl.innerHTML = '';
    for (var i = 0; i < 40; i++) {
      var s = document.createElement('span');
      s.style.left = (Math.random() * 100) + '%';
      s.style.background = colors[Math.floor(Math.random() * colors.length)];
      s.style.animationDuration = (2.2 + Math.random() * 1.8) + 's';
      s.style.animationDelay = (Math.random() * 0.4) + 's';
      s.style.width = (4 + Math.random() * 4) + 'px';
      s.style.height = (6 + Math.random() * 8) + 'px';
      s.style.opacity = (0.7 + Math.random() * 0.3).toFixed(2);
      s.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
      confettiEl.appendChild(s);
    }
    setTimeout(function() { confettiEl.innerHTML = ''; }, 4500);
  }

  function setState(name) {
    var states = overlay.querySelectorAll('[data-wr-state]');
    for (var i = 0; i < states.length; i++) {
      states[i].classList.toggle('is-active', states[i].getAttribute('data-wr-state') === name);
    }
  }

  // ── Postcode validation ──────────────────────────────────────────────

  async function validatePostcode(postcode) {
    var cleanPostcode = postcode.trim().replace(/\s+/g, '');
    if (cleanPostcode.length < 5) return { valid: false, message: '' };

    if (market === 'US') {
      var usZipPattern = /^[0-9]{5}(-[0-9]{4})?$/;
      var valid = usZipPattern.test(cleanPostcode);
      return { valid: valid, message: valid ? '' : 'Invalid US ZIP code' };
    }

    try {
      var response = await fetch(CONFIG.postcodeApiUrl + '/' + encodeURIComponent(cleanPostcode) + '/validate');
      var data = await response.json();
      return { valid: data.result === true, message: data.result === true ? '' : 'Invalid UK postcode' };
    } catch (error) {
      return { valid: false, message: 'Unable to validate postcode' };
    }
  }

  function updatePostcodeUI(state) {
    if (!zipcodeInput) return;
    var formGroup = zipcodeInput.closest('.wr-form-group');
    var errorEl = formGroup && formGroup.querySelector('.wr-postcode-error');
    zipcodeInput.classList.remove('is-valid', 'is-invalid', 'is-validating');

    if (state === 'validating') {
      zipcodeInput.classList.add('is-validating');
      if (errorEl) errorEl.textContent = '';
    } else if (state === 'valid') {
      zipcodeInput.classList.add('is-valid');
      if (errorEl) errorEl.textContent = '';
    } else if (state === 'invalid') {
      zipcodeInput.classList.add('is-invalid');
    } else {
      if (errorEl) errorEl.textContent = '';
    }

    updateSubmitButton();
  }

  function showPostcodeError(message) {
    if (!zipcodeInput) return;
    var formGroup = zipcodeInput.closest('.wr-form-group');
    var errorEl = formGroup && formGroup.querySelector('.wr-postcode-error');
    if (!errorEl && formGroup) {
      errorEl = document.createElement('span');
      errorEl.className = 'wr-postcode-error';
      formGroup.appendChild(errorEl);
    }
    if (errorEl) errorEl.textContent = message;
  }

  function handlePostcodeInput() {
    isPostcodeValid = false;
    if (validationTimeout) clearTimeout(validationTimeout);
    var value = (zipcodeInput && zipcodeInput.value.trim()) || '';
    if (value.length < 5) { updatePostcodeUI('neutral'); return; }
    updatePostcodeUI('validating');
    validationTimeout = setTimeout(async function() {
      var result = await validatePostcode(value);
      isPostcodeValid = result.valid;
      if (result.valid) {
        updatePostcodeUI('valid');
      } else {
        updatePostcodeUI('invalid');
        if (result.message) showPostcodeError(result.message);
      }
    }, CONFIG.debounceDelay);
  }

  function updateSubmitButton() {
    if (!submitBtn) return;
    var emailInput = form && form.querySelector('#wr-email');
    var emailValid = (emailInput && emailInput.validity && emailInput.validity.valid) || false;
    var canSubmit = emailValid && isPostcodeValid;
    submitBtn.disabled = !canSubmit;
    submitBtn.classList.toggle('is-disabled', !canSubmit);
  }

  // ── Session / tracking ───────────────────────────────────────────────

  function generateUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getPopupSessionId() {
    if (popupSessionId) return popupSessionId;
    try {
      var existing = localStorage.getItem(CONFIG.sessionIdKey);
      if (existing) { popupSessionId = existing; return popupSessionId; }
    } catch (e) {}
    popupSessionId = generateUUID();
    try { localStorage.setItem(CONFIG.sessionIdKey, popupSessionId); } catch (e) {}
    return popupSessionId;
  }

  async function trackPopupImpression() {
    if (impressionTracked) return;
    try { if (sessionStorage.getItem(CONFIG.impressionTrackedKey) === 'true') return; } catch (e) {}
    var sessionId = getPopupSessionId();
    try {
      await fetch(CONFIG.supabaseImpressionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + CONFIG.supabaseAnonKey, 'apikey': CONFIG.supabaseAnonKey },
        body: JSON.stringify({ popup_session_id: sessionId })
      });
      impressionTracked = true;
      try { sessionStorage.setItem(CONFIG.impressionTrackedKey, 'true'); } catch (e) {}
    } catch (err) { console.error('[WR] impression tracking failed:', err); }
  }

  async function trackFormSubmission(email, sessionId) {
    try {
      await fetch(CONFIG.supabaseFormSubmissionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + CONFIG.supabaseAnonKey, 'apikey': CONFIG.supabaseAnonKey },
        body: JSON.stringify({ popup_session_id: sessionId, email: email })
      });
    } catch (err) { console.error('[WR] submission tracking failed:', err); }
  }

  // ── Popup show/hide ──────────────────────────────────────────────────

  function showPopup() {
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    getPopupSessionId();
    trackPopupImpression();
    isPostcodeValid = false;
    updateSubmitButton();
    document.addEventListener('keydown', handleKeydown);
  }

  function hidePopup() {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleKeydown);
    try { sessionStorage.setItem(marketStorageKey, 'true'); } catch (e) {}
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') hidePopup();
  }

  // ── Form submit ──────────────────────────────────────────────────────

  async function handleSubmit(e) {
    e.preventDefault();

    var emailInput = form.querySelector('#wr-email');
    var phoneInput = form.querySelector('#wr-phone');
    if (!emailInput || !phoneInput || !zipcodeInput) return;
    if (!isPostcodeValid) { showPostcodeError('Please enter a valid ' + (market === 'US' ? 'ZIP code' : 'UK postcode')); return; }

    var data = {
      email: emailInput.value.trim(),
      phone: phoneInput.value.trim(),
      zipcode: zipcodeInput.value.trim(),
      popup_session_id: getPopupSessionId(),
      source: 'popup',
      market: form.dataset.market || 'UK'
    };

    if (!data.email || !data.zipcode) return;

    try { localStorage.setItem(marketStorageKey + '_submitted', 'true'); } catch (e) {}
    try { sessionStorage.setItem(marketStorageKey, 'true'); } catch (e) {}

    // Switch to confirmation state
    setState('done');
    fireConfetti();

    // Fire-and-forget background calls
    trackFormSubmission(data.email, data.popup_session_id);
    var webhookUrl = (market === 'US' && CONFIG.webhookUrlUS) ? CONFIG.webhookUrlUS : CONFIG.webhookUrl;
    fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).catch(function(err) { console.error('[WR] webhook error:', err); });
  }

  // ── Market check ─────────────────────────────────────────────────────

  function shouldShowPopup() {
    try {
      if (localStorage.getItem(marketStorageKey + '_submitted')) return false;
      if (sessionStorage.getItem(marketStorageKey)) return false;
    } catch (e) {}
    return true;
  }

  async function checkMarketEnabled(mkt) {
    try {
      var resp = await fetch('/apps/water-report?action=market-status&market=' + encodeURIComponent(mkt));
      if (!resp.ok) return true;
      var data = await resp.json();
      return data.enabled !== false;
    } catch (err) { return true; }
  }

  // ── Init ─────────────────────────────────────────────────────────────

  function init() {
    overlay      = document.getElementById('water-report-overlay');
    modal        = overlay && overlay.querySelector('.wr-popup-modal');
    closeBtn     = overlay && overlay.querySelector('.wr-popup-close');
    form         = document.getElementById('wr-popup-form');
    submitBtn    = form && form.querySelector('.wr-form-submit');
    zipcodeInput = form && form.querySelector('#wr-zipcode');
    wheelEl      = overlay && overlay.querySelector('[data-wr-wheel]');
    wheelSvg     = overlay && overlay.querySelector('[data-wr-wheel-svg]');
    hubEl        = overlay && overlay.querySelector('[data-wr-spin]');
    confettiEl   = overlay && overlay.querySelector('[data-wr-confetti]');

    if (!overlay || !modal || !form) {
      console.warn('[WR Popup] Required elements not found — aborting');
      return;
    }

    var shopifyCountry = (typeof Shopify !== 'undefined' && Shopify.country) ? Shopify.country : null;
    var ALLOWED_COUNTRIES = ['GB'];
    if (!shopifyCountry || !ALLOWED_COUNTRIES.includes(shopifyCountry)) {
      console.warn('[WR Popup] Country not allowed:', shopifyCountry);
      return;
    }

    market = shopifyCountry === 'GB' ? 'UK' : 'US';
    form.dataset.market = market;
    marketStorageKey = CONFIG.storageKey + '_' + market.toLowerCase();

    if (market === 'US' && zipcodeInput) {
      zipcodeInput.placeholder = 'Your ZIP code (e.g. 10001)';
      zipcodeInput.pattern = '[0-9]{5}(-[0-9]{4})?';
      zipcodeInput.maxLength = 10;
    }

    // Build wheel
    if (wheelEl && wheelSvg && hubEl) {
      buildWheel();
      hubEl.addEventListener('click', spin);
    }

    // Close handlers
    closeBtn && closeBtn.addEventListener('click', hidePopup);

    var doneClose = document.getElementById('wr-done-close');
    if (doneClose) doneClose.addEventListener('click', hidePopup);

    // Form handlers
    form.addEventListener('submit', handleSubmit);
    zipcodeInput && zipcodeInput.addEventListener('input', handlePostcodeInput);
    var emailInput = form.querySelector('#wr-email');
    emailInput && emailInput.addEventListener('input', updateSubmitButton);
    updateSubmitButton();

    // Excluded pages
    var path = window.location.pathname;
    if (path.indexOf('/pages/quizz-funnel') !== -1 ||
        path.indexOf('/apps/quizz-funnel') !== -1 ||
        path.indexOf('/pages/analyze-my-water') !== -1) {
      return;
    }

    if (shouldShowPopup()) {
      checkMarketEnabled(market).then(function(enabled) {
        if (!enabled) return;
        setTimeout(showPopup, CONFIG.showDelay);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
